// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// =============== Base libraries integration ==================
import Vue from "vue";
import VueTranslate from "vue-translate-plugin";
import axios from "axios";
import VueAxios from "vue-axios";
import wysiwyg from "vue-wysiwyg";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);
Vue.use(VueAxios, axios);
Vue.use(wysiwyg, {
  hideModules: {
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    link: true,
    code: true,
    orderedList: true,
    unorderedList: true,
    image: true,
    table: true,
    removeFormat: true,
    separator: true,
  },
  forcePlainTextOnPaste: true,
}); // config is optional. more below

// document.addEventListener('paste', function (e) {
//     e.preventDefault();
//     document.execCommand("insertHTML", false, e.clipboardData.getData("text/plain"));
// });
Vue.use(VueTranslate);

import store from "./store";
import router from "./router";

// ===== Bootstrap components integration (JQuery needed) ======
window.$ = window.jQuery = require("jquery");
require("bootstrap-sass");

// ======================= Base Component ======================
import App from "./App";

// ======================== Vue Instance =======================
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: "#app",
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js